import { render, staticRenderFns } from "./CompanyAnnoucements.vue?vue&type=template&id=08478d32&scoped=true"
import script from "./CompanyAnnoucements.vue?vue&type=script&lang=js"
export * from "./CompanyAnnoucements.vue?vue&type=script&lang=js"
import style0 from "./CompanyAnnoucements.vue?vue&type=style&index=0&id=08478d32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08478d32",
  null
  
)

export default component.exports